import appLocaleData from 'react-intl/locale-data/br';
import brMessages from '../locales/pt-BR.json';

const brLang = {
    messages: {
        ...brMessages
    },
    locale: 'br',
    data: appLocaleData
};
export default brLang;
